var exports = {
  "i": "x31de4314--f80375--wrapper",
  "Y": "x31de4314--f80375--tooltip",
};

module.exports = exports;
